import { getXVerdictSlaRuntimes } from '@/services/xverdict_sla_service';
import { error_message, normalize_text } from './view_case_details_helpers';

const PRIMARY_RUNTIME_STATUSES = ['breached', 'escalated', 'warning', 'active'];

function runtime_priority(runtime = {}) {
  const status = normalize_text(runtime.status).toLowerCase();
  const index = PRIMARY_RUNTIME_STATUSES.indexOf(status);
  return index === -1 ? PRIMARY_RUNTIME_STATUSES.length : index;
}

function sort_runtimes(left = {}, right = {}) {
  const priority_difference = runtime_priority(left) - runtime_priority(right);
  if (priority_difference) return priority_difference;

  return Date.parse(right.started_at || 0) - Date.parse(left.started_at || 0);
}

function normalize_runtime(runtime = {}) {
  return {
    ...runtime,
    id: runtime.id,
    name: normalize_text(runtime.sla_name),
    status_label: normalize_text(runtime.status_label),
    time_label: normalize_text(runtime.time_label),
    badge_label: normalize_text(runtime.badge_label),
    tone_class: normalize_text(runtime.tone_class) || 'is-neutral',
    workflow_status_name: normalize_text(runtime.workflow_status_name),
    due_label: runtime.due_at ? new Date(runtime.due_at).toLocaleString('en-ZA') : '',
  };
}

function sla_runtime_params(component) {
  return {
    application_id: component.selected_application_id,
    entity_profile_id: component.selected_application_id ? null : component.selected_entity_profile_id,
  };
}

function reset_sla_runtimes(component) {
  component.loading_sla_runtimes = false;
  component.sla_runtimes_error = '';
  component.sla_runtimes = [];
}

export default {
  async load_sla_runtimes() {
    reset_sla_runtimes(this);

    if (!this.selected_application_id && !this.selected_entity_profile_id) {
      return;
    }

    this.loading_sla_runtimes = true;

    try {
      this.sla_runtimes = (await getXVerdictSlaRuntimes(sla_runtime_params(this)))
        .map(normalize_runtime)
        .sort(sort_runtimes);
    } catch (error) {
      this.sla_runtimes_error = error_message(error, 'Failed to load SLA runtimes.');
      this.sla_runtimes = [];
    } finally {
      this.loading_sla_runtimes = false;
    }
  },
};
